import { render, staticRenderFns } from "./InvoiceStatusLabel.vue?vue&type=template&id=22a35abe&"
import script from "./InvoiceStatusLabel.vue?vue&type=script&lang=js&"
export * from "./InvoiceStatusLabel.vue?vue&type=script&lang=js&"
import style0 from "./InvoiceStatusLabel.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports